"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setItemColor = void 0;
const styled_components_1 = require("styled-components");
const styles_1 = require("./styles");
const theme_1 = require("@icr-ui/theme");
const setItemColor = ({ isVertical, isStepCurrent, isStepCompleted, }) => {
    if (isVertical) {
        return (0, styled_components_1.css) `
      ${styles_1.StyledStepbarDescription} {
        color: ${theme_1.palette.grayScale[600]};
      }
    `;
    }
    else {
        if (isStepCurrent) {
            return (0, styled_components_1.css) `
        ${styles_1.StyledStepbarDescription} {
          color: ${theme_1.palette.primary.light};
        }
      `;
        }
        else if (isStepCompleted) {
            return (0, styled_components_1.css) `
        ${styles_1.StyledStepbarDescription} {
          color: ${theme_1.palette.grayScale[900]};
        }
      `;
        }
        else {
            return (0, styled_components_1.css) `
        ${styles_1.StyledStepbarDescription} {
          color: ${theme_1.palette.grayScale[600]};
        }
      `;
        }
    }
};
exports.setItemColor = setItemColor;
//# sourceMappingURL=utils.js.map